/* generated by pull.js */
const manifest = {
  "noTranslations": true,
  "name": "Remove Back to Home button",
  "description": "Removes the Back to Home button from the menu bar.",
  "userstyles": [
    {
      "url": "remove-feedback.css"
    }
  ],
  "tags": [],
  "dynamicDisable": true,
  "enabledByDefault": false
};
export default manifest;
